import { esc } from "./utils.js";

/**
 * A photo, enlarged over the page: the chat's photos, which have no page of
 * their own (they aren't in any gallery). Closed by the × in its corner, by
 * Escape or by clicking outside the photo; removed from the page once closed.
 */
export function openPhotoViewer(url, { alt = "" } = {}) {
  const host = document.createElement("div");
  host.innerHTML = `
    <div class="modal fade dc-photo-viewer" tabindex="-1" aria-label="Photo" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content bg-transparent border-0 position-relative">
          <button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-2 dc-photo-viewer-close"
                  data-bs-dismiss="modal" aria-label="Close"></button>
          <img src="${esc(url)}" alt="${esc(alt)}" class="img-fluid rounded mx-auto d-block dc-photo-viewer-img" />
        </div>
      </div>
    </div>`;
  const el = host.firstElementChild;
  document.body.appendChild(el);
  const modal = new bootstrap.Modal(el);
  el.addEventListener("hidden.bs.modal", () => el.remove());
  modal.show();
  return modal;
}
